module.exports = "/images/reserved-3-year-seller.png?cd4aff00cafa68ec98151b5098374031";